<div class="row">
  <!-- start date picker -->
  <div [class]="config?.responsiveClassName || 'md:tw-w-1/2 tw-px-1'">
    <datepicker
      [isEdit]="config?.isEditMode"
      [label]="config?.startDateLabel"
      [control]="config?.startDateFormControl"
      [minType]="config?.isEditMode ? 'unlimited' : config?.minStartDateType"
      [maxType]="endDate ? 'custom' : config?.maxStartDateType || 'unlimited'"
      [max]="endDate"
      [isAdvancedSearch]="config?.isAdvancedSearch"
      [value]="startDate"
      (value)="startDate = $event; combineDateAndTime(); checkMinMaxTime()"
      (onErrorDatePicker)="showErrorDialog($event)"
    >
    </datepicker>
  </div>

  <!-- start time picker -->
  <div [class]="config?.responsiveClassName || 'md:tw-w-1/2 tw-px-1'">
    <timepicker
      [label]="config?.startTimeLabel"
      [control]="config?.startTimeFormControl"
      [minType]="config?.minStartTimeType"
      [maxType]="
        maxStartTime ? 'custom' : config?.maxStartTimeType || 'lastTime'
      "
      [maxTime]="maxStartTime"
      [value]="startTime"
      (value)="startTime = $event; combineDateAndTime(); checkMinMaxTime()"
      [confirmBtnClass]="'btn' | themeColor"
    >
    </timepicker>
  </div>

  <!-- end date picker -->
  <div [class]="config?.responsiveClassName || 'md:tw-w-1/2 tw-px-1'">
    <datepicker
      [isEdit]="config?.isEditMode"
      [label]="config?.endDateLabel"
      [control]="config?.endDateFormControl"
      [maxType]="config?.maxEndDateType"
      [minType]="startDate ? 'custom' : config?.minStartDateType || 'unlimited'"
      [min]="startDate"
      [isAdvancedSearch]="config?.isAdvancedSearch"
      [value]="endDate"
      (value)="endDate = $event; combineDateAndTime(); checkMinMaxTime()"
      (onErrorDatePicker)="showErrorDialog($event)"
    >
    </datepicker>
  </div>

  <!-- end time picker -->
  <div [class]="config?.responsiveClassName || 'md:tw-w-1/2 tw-px-1'">
    <timepicker
      [label]="config?.endTimeLabel"
      [control]="config?.endTimeFormControl"
      [minType]="minEndTime ? 'custom' : config?.minEndTimeType || 'firstTime'"
      [minTime]="minEndTime"
      [maxType]="config?.maxEndTimeType"
      [value]="endTime"
      (value)="endTime = $event; combineDateAndTime(); checkMinMaxTime()"
    >
    </timepicker>
  </div>

  <span class="text-danger" *ngIf="isShowError">
    *
    {{ "messages.periodDateTimeErrorMsg" | translate }}
  </span>
</div>
